import React from "react";
import styles from "./Login.module.css";
import LoginForm from "../../components/Forms/LoginForm/LoginForm";
import StoreGuide from "../Static/StoreGuide";

const Login: React.FC = () => {
  return (
    <div>
      <div className={styles.mainContainer}>
        <div className={styles.leftPanelContainer}>
          <div className={styles.header}>
            <img
              className={styles.logo}
              src="/images/logo/company.svg"
              alt="logo"
            />
            <h2>Design&share your card</h2>
          </div>
        </div>
        <div className={styles.container}>
          <div className={styles.loginFormContainer}>
            <LoginForm />
          </div>
        </div>
      </div>
      <StoreGuide />
    </div>
  );
};

export default Login;
